// extracted by mini-css-extract-plugin
export default {"root":"Topinfo__root--25OAC","content":"Topinfo__content--1KaBQ","close":"Topinfo__close--1jkyH","close_dark":"Topinfo__close_dark--1Om2b"};